<gd-product-add-button
  class="cy-header-create-menu"
  [isMobile]="isMobile"
  [positionLeft]="true"
  [canAddExistingProduct]="false"
  [showUploadDesign]="true"
  (addNewProductClick)="onAddNewProduct()"
  (designUpload)="uploadDesign()"
  [triggerElementRef]="buttonContent"
>
</gd-product-add-button>

<ng-template #buttonContent>
  <div
    class="ui secondary-grey button header-create-menu"
    [class.header-create-menu-desktop]="!isMobile"
    [class.header-create-menu-mobile]="isMobile"
    uiLogEvent
    [analyticsKey]="GelatoPublisherEventName.CREATE_HEADER_BUTTON_CLICKED"
    [analyticsEventVersion]="2"
  >
    <img [src]="'icons/add-product-small.svg' | assetsPath | async" width="20" height="20" />
    <span data-lokalise data-key="txt_header_create_menu_button"></span>
  </div>
</ng-template>
